import { find, get } from "lodash-es";

export default {
  methods: {
    setTheme() {
      const user = this.$store.getters["auth/getUserData"];

      if (user && user.organization.colorTheme) {
        this.colour =
          user.organization.code === "QOALA-CAMPAIGN"
            ? "campaign"
            : this.$helpers.colourDashborad(
                get(user, "organization.colorTheme.primary", ""),
              );
        this.$store.dispatch("appPersisted/setColorTheme", this.colour);
      } else {
        const partnerCode = process.env.PARTNER_CODE;

        if (partnerCode && partnerCode !== "GENERAL") {
          this.$store.dispatch(
            "appPersisted/setColorTheme",
            partnerCode.toLocaleLowerCase(),
          );
          return;
        }
        this.$store.dispatch("appPersisted/setColorTheme", "black-and-white");
      }
    },

    defineVisibility() {
      return this.$ui.defineSidebarMenuVisibility(this.menus);
    },

    checkingLocale() {
      const locale = this.$store.getters["appPersisted/getLocale"];

      // url language (this.$i18n.locale) available on list
      if (
        locale !== this.$i18n.locale &&
        find(this.itemsLanguage, (item) => item.value === this.$i18n.locale)
      ) {
        this.$i18n.setLocale(this.$i18n.locale);
        this.$store.dispatch("appPersisted/setLocale", this.$i18n.locale);
      }

      // language unavailable on list
      if (
        !find(this.itemsLanguage, (item) => item.value === this.$i18n.locale)
      ) {
        this.$i18n.setLocale(this.$i18n.defaultLocale);
        this.$store.dispatch(
          "appPersisted/setLocale",
          this.$i18n.defaultLocale,
        );
      }
    },
  },
};
